import { shallowRef, computed } from 'vue'
import type { Component } from 'vue'
import type { SheetStackEntry, SheetStackMeta } from '@/types/sheet-stack'

const stack = shallowRef<SheetStackEntry[]>([])
let idCounter = 0

// Sync browser back button with sheet stack
window.addEventListener('popstate', () => {
  if (stack.value.length > 0) {
    stack.value = stack.value.slice(0, -1)
  }
})

export function clearSheets() {
  stack.value = []
}

export function useSheetStack() {
  const current = computed(() => stack.value[stack.value.length - 1] ?? null)
  const isOpen = computed(() => stack.value.length > 0)
  const size = computed(() => stack.value.length)

  function push(component: Component, props?: Record<string, unknown>, meta?: SheetStackMeta) {
    stack.value = [...stack.value, { id: String(++idCounter), component, props, meta }]
    window.history.pushState({ _sheetStack: true, depth: stack.value.length }, '', location.href)
  }

  function pop() {
    if (stack.value.length === 0) {
      return
    }
    // history.back() fires popstate → popstate listener pops the stack
    window.history.back()
  }

  function clear(): Promise<void> {
    const depth = stack.value.length
    if (depth === 0) {
      return Promise.resolve()
    }
    stack.value = []
    return new Promise((resolve) => {
      const onPopstate = () => {
        window.removeEventListener('popstate', onPopstate)
        resolve()
      }
      window.addEventListener('popstate', onPopstate)
      window.history.go(-depth)
    })
  }

  return { current, isOpen, size, push, pop, clear }
}
